/* OVD Wishlist — localStorage hearts + header count + wishlist-page render.
   Rendering lives here (persistent, deferred script) rather than inline in the
   section, so it survives the theme's custom SPA page swaps (ovd-fluid.js): a
   MutationObserver + nav-event hooks catch the grid whenever it appears, on
   full loads AND ajax navigations.
   API: window.OvdWishlist { has, toggle, list, count } */
(function () {
  if (window.OvdWishlist) return;
  var KEY = 'ovd_wishlist';

  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} syncUI(); }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i === -1) l.unshift(h); else l.splice(i, 1);
    write(l);
    if (i === -1) trackHeart(h);
    return i === -1;
  }
  function trackHeart(h) {
    // Enrich from the product API so the Klaviyo event always carries full
    // title/price/image — DOM scraping missed fields on some surfaces.
    try {
      var k = window.klaviyo || window._learnq;
      if (!k || typeof k.push !== 'function') return;
      fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var props = { Handle: h, URL: location.origin + '/products/' + h };
          if (p) {
            props.ProductName = p.title;
            props.ProductID = p.id;
            props.Price = (p.price || 0) / 100;
            props.ImageURL = p.featured_image || '';
            props.Brand = p.vendor || 'OVD';
            props.Available = p.available;
          }
          k.push(['track', 'Added to Wishlist', props]);
        }).catch(function () {
          k.push(['track', 'Added to Wishlist', { Handle: h, URL: location.origin + '/products/' + h }]);
        });
    } catch (e) {}
  }

  function money(val) {
    var n = (typeof val === 'string') ? Number(val) : Number(val) / 100;
    if (!isFinite(n)) return '';
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(n).replace(/([.,]00)(?=\s|$)/, ''); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }

  // ---- Heart buttons + header count ----
  function syncUI() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wishlist-handle')) !== -1;
      btn.classList.toggle('is-saved', on);
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = on ? 'SAVED TO WISHLIST' : 'ADD TO WISHLIST';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length; el.hidden = list.length === 0;
    });
  }
  function heartHandler(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (e.type === 'click') toggle(btn.getAttribute('data-wishlist-handle'));
  }
  document.addEventListener('pointerdown', heartHandler, true);
  document.addEventListener('click', heartHandler, true);

  function wlPageHandler(e) {
    var rm = e.target.closest('[data-wl-remove]');
    var add = e.target.closest('[data-wl-add]');
    if (!rm && !add) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.type !== 'click') return;
    if (rm) {
      var h = rm.getAttribute('data-wl-remove'), l = read(), i = l.indexOf(h);
      if (i !== -1) { l.splice(i, 1); write(l); }
      var card = rm.closest('.wl-card'); if (card) card.remove();
      var countEl = document.querySelector('[data-wishlist-page-count]');
      var empty = document.querySelector('[data-wishlist-empty]');
      if (countEl) countEl.textContent = l.length + ' saved';
      if (!l.length && empty) empty.hidden = false;
      return;
    }
    if (add.disabled) return;
    add.disabled = true; var orig = add.textContent; add.textContent = 'ADDING...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(add.getAttribute('data-wl-add')), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); add.textContent = 'ADDED'; document.dispatchEvent(new CustomEvent('cart:add')); setTimeout(function () { add.textContent = orig; add.disabled = false; }, 1500); })
      .catch(function () { add.textContent = 'ERROR'; setTimeout(function () { add.textContent = orig; add.disabled = false; }, 2000); });
  }
  document.addEventListener('pointerdown', wlPageHandler, true);
  document.addEventListener('click', wlPageHandler, true);

  // ---- Wishlist page render ----
  function skeleton(idx) {
    return '<div class="wl-card wl-skel" data-wl-slot="' + idx + '"><div class="wl-card-media"></div>'
      + '<div class="wl-card-info"><span class="wl-sk-line"></span><span class="wl-sk-line wl-sk-short"></span><span class="wl-sk-btn"></span></div></div>';
  }
  function cardHtml(p, opts) {
    opts = opts || {};
    var img = (p.featured_image || '').replace(/(\.[a-z]{3,4})(\?|$)/i, '_600x$1$2');
    var avail = p.available, one = p.variants.length === 1, btn;
    if (!avail) btn = '<button type="button" class="wl-card-btn" disabled>SOLD OUT</button>';
    else if (one) btn = '<button type="button" class="wl-card-btn" data-wl-add="' + p.variants[0].id + '">ADD TO CART</button>';
    else btn = '<a href="' + esc(p.url) + '" class="wl-card-btn wl-card-btn--link">SELECT SIZE</a>';
    return '<div class="wl-card" data-wl-handle="' + esc(p.handle) + '">'
      + '<a href="' + esc(p.url) + '" class="wl-card-media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '')
      + (opts.readOnly ? '</a>' : '<button type="button" class="wl-card-remove" data-wl-remove="' + esc(p.handle) + '" aria-label="Remove from wishlist">&times;</button></a>')
      + '<div class="wl-card-info"><a href="' + esc(p.url) + '" class="wl-card-title">' + esc(p.title) + '</a>'
      + '<span class="wl-card-price">' + money(p.price) + '</span>' + btn + '</div></div>';
  }
  function renderWishlistPage() {
    var grid = document.getElementById('ovd-wishlist-grid');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var countEl = document.querySelector('[data-wishlist-page-count]');

    // Shared wishlist view: /pages/wishlist?wl=handle1,handle2
    var wlParam = null;
    try { wlParam = new URLSearchParams(location.search).get('wl'); } catch (e) {}
    var shared = wlParam ? wlParam.split(',').filter(Boolean).slice(0, 50) : null;
    var list = shared || read();
    var header = document.querySelector('.wishlist-header');

    if (shared) {
      if (countEl) countEl.textContent = shared.length + ' items';
      if (header && !document.querySelector('.wl-shared-banner')) {
        var banner = document.createElement('div');
        banner.className = 'wl-shared-banner';
        banner.innerHTML = '<span>Viewing a shared wishlist</span>'
          + '<span class="wl-shared-actions">'
          + '<button type="button" class="wl-share" data-wl-saveall>SAVE ALL TO MINE</button>'
          + '<a class="wl-share wl-share--ghost" href="/pages/wishlist">VIEW MINE</a></span>';
        header.parentNode.insertBefore(banner, header.nextSibling);
        banner.querySelector('[data-wl-saveall]').addEventListener('click', function () {
          var mine = read();
          shared.forEach(function (h) { if (mine.indexOf(h) === -1) mine.push(h); });
          write(mine);
          location.href = '/pages/wishlist';
        });
      }
    } else {
      if (countEl) countEl.textContent = list.length + ' saved';
      if (header && list.length && !header.querySelector('[data-wl-share]')) {
        var share = document.createElement('button');
        share.type = 'button';
        share.className = 'wl-share';
        share.setAttribute('data-wl-share', '');
        share.textContent = 'SHARE';
        header.appendChild(share);
        share.addEventListener('click', function () {
          var url = location.origin + '/pages/wishlist?wl=' + read().join(',');
          function copied() { share.textContent = 'LINK COPIED'; setTimeout(function () { share.textContent = 'SHARE'; }, 1800); }
          if (navigator.share) { navigator.share({ title: 'my OVD wishlist', url: url }).catch(function () {}); }
          else if (navigator.clipboard) { navigator.clipboard.writeText(url).then(copied).catch(function () {}); }
          else { window.prompt('Copy your wishlist link:', url); }
        });
      }
    }

    // Chrome above is idempotent; the card render below runs once per page
    // (the wishlist section's inline script may have already done it).
    if (grid.dataset.ovdRendered) return;
    grid.dataset.ovdRendered = '1';

    if (!list.length) { if (empty) empty.hidden = false; return; }

    grid.innerHTML = list.map(function (h, i) { return skeleton(i); }).join('');
    var pre = window.__ovdWLPrefetch || {};
    list.forEach(function (h, idx) {
      var job = pre[h] || fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; });
      job.then(function (p) {
        var slot = grid.querySelector('[data-wl-slot="' + idx + '"]');
        if (!slot) return;
        if (p) slot.outerHTML = cardHtml(p, { readOnly: !!shared }); else slot.remove();
      }).catch(function () {
        var slot = grid.querySelector('[data-wl-slot="' + idx + '"]');
        if (slot) slot.remove();
      });
    });

  }

  window.OvdWishlist = { has: has, toggle: toggle, list: read, count: function () { return read().length; }, _sync: syncUI, _render: renderWishlistPage };

  function scan() { syncUI(); renderWishlistPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  // The theme's SPA (ovd-fluid.js) dispatches barba-style events on page swap.
  ['barba:after', 'barba:enter', 'barba:afterEnter'].forEach(function (ev) { window.addEventListener(ev, function () { setTimeout(scan, 0); }); });
  // Safety net: catch the wishlist grid whenever it enters the DOM via any swap.
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.id === 'ovd-wishlist-grid') || (n.querySelector && n.querySelector('#ovd-wishlist-grid'))) { scan(); return; }
        if (n.querySelector && n.querySelector('[data-wishlist-toggle]')) syncUI();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
